"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeUnit = void 0;
var type_guard_1 = require("@webnuts/type-guard");
exports.timeUnit = type_guard_1.pattern(/^\d*(?:\.\d+)?(ms|s)$/);
